// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background-color: #f8f8f8;
}

.layout-card {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #f8f8f8;
}

.login_card {
  width: 100%;
  max-width: 340px;
  padding: 32px;
  background-color: #ffffff;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.btn_primary {
  color: #ffffff;
  background-color: #7d2e84;
  font-size: 15px;
  margin-top: 40px;
}

.btn_primary:hover {
  color: #ffffff;
  background-color: #ae43b8 !important;
}

.ant-checkbox .ant-checkbox-inner {
  width: 20px !important;
  height: 20px !important;
  border-radius: 4px !important;
}

.ant-checkbox-checked .ant-checkbox-inner {
  background-color: #7d2e84 !important;
  border-color: #7d2e84 !important;
}

.ant-checkbox-checked:hover .ant-checkbox-inner {
  background-color: #7d2e84 !important;
  border-color: #7d2e84 !important;
}

.ant-checkbox:hover .ant-checkbox-inner {
  border-color: #7d2e84 !important;
}

.ant-checkbox-wrapper:hover .ant-checkbox-inner {
  border-color: #7d2e84 !important;
}

.ant-input-affix-wrapper .ant-input-prefix {
  margin-inline-end: 12px !important;
  color: #b0b0b0;
}

.ant-input-affix-wrapper .anticon.ant-input-password-icon {
  color: #b0b0b0;
}

.ant-input-outlined:hover {
  border-color: #7d2e84 !important;
}

.ant-input-outlined:focus-within {
  box-shadow: 0 0 0 2px rgba(0, 0, 0, 0.1) !important;
}

.ant-input {
  font-size: 14px !important;
}

.ant-form-item {
  margin-bottom: 0 !important;
}

.ant-form-item .ant-form-item-explain-error {
  padding-top: 4px;
  margin-bottom: 24px !important;
  font-size: 13px;
}

.input {
  margin-bottom: 24px !important;
}
`, "",{"version":3,"sources":["webpack://./src/components/Login/login.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,wCAAwC;AAC1C;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,oCAAoC;AACtC;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,6BAA6B;AAC/B;;AAEA;EACE,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA;EACE,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,mDAAmD;AACrD;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,8BAA8B;EAC9B,eAAe;AACjB;;AAEA;EACE,8BAA8B;AAChC","sourcesContent":[".container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 100vh;\n  background-color: #f8f8f8;\n}\n\n.layout-card {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background-color: #f8f8f8;\n}\n\n.login_card {\n  width: 100%;\n  max-width: 340px;\n  padding: 32px;\n  background-color: #ffffff;\n  border-radius: 12px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n}\n\n.btn_primary {\n  color: #ffffff;\n  background-color: #7d2e84;\n  font-size: 15px;\n  margin-top: 40px;\n}\n\n.btn_primary:hover {\n  color: #ffffff;\n  background-color: #ae43b8 !important;\n}\n\n.ant-checkbox .ant-checkbox-inner {\n  width: 20px !important;\n  height: 20px !important;\n  border-radius: 4px !important;\n}\n\n.ant-checkbox-checked .ant-checkbox-inner {\n  background-color: #7d2e84 !important;\n  border-color: #7d2e84 !important;\n}\n\n.ant-checkbox-checked:hover .ant-checkbox-inner {\n  background-color: #7d2e84 !important;\n  border-color: #7d2e84 !important;\n}\n\n.ant-checkbox:hover .ant-checkbox-inner {\n  border-color: #7d2e84 !important;\n}\n\n.ant-checkbox-wrapper:hover .ant-checkbox-inner {\n  border-color: #7d2e84 !important;\n}\n\n.ant-input-affix-wrapper .ant-input-prefix {\n  margin-inline-end: 12px !important;\n  color: #b0b0b0;\n}\n\n.ant-input-affix-wrapper .anticon.ant-input-password-icon {\n  color: #b0b0b0;\n}\n\n.ant-input-outlined:hover {\n  border-color: #7d2e84 !important;\n}\n\n.ant-input-outlined:focus-within {\n  box-shadow: 0 0 0 2px rgba(0, 0, 0, 0.1) !important;\n}\n\n.ant-input {\n  font-size: 14px !important;\n}\n\n.ant-form-item {\n  margin-bottom: 0 !important;\n}\n\n.ant-form-item .ant-form-item-explain-error {\n  padding-top: 4px;\n  margin-bottom: 24px !important;\n  font-size: 13px;\n}\n\n.input {\n  margin-bottom: 24px !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
